if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"OP-WRAPPER","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(3(301|858|888)|(240|497|809)6|1747|2164|9817)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}